import React, { useMemo } from 'react';
import { useLanguage } from '../../../utils/useLanguage';
import { MicChromeGif, MicEdgeGif, MicFirefoxGif, MicSafariGif, CloseIcon } from '../../../../../assets/images';
import { hidePopup } from '../../../utils/popupService';
import './MicrophonePermissionPopup.scss';

const MicrophonePermissionPopup = () => {
    const { t } = useLanguage();

    const getBrowserGif = useMemo(() => {
        const userAgent = navigator.userAgent.toLowerCase();
        if (userAgent.indexOf('edg/') > -1) return MicEdgeGif;
        if (userAgent.indexOf('chrome') > -1) return MicChromeGif;
        if (userAgent.indexOf('firefox') > -1) return MicFirefoxGif;
        if (userAgent.indexOf('safari') > -1 && userAgent.indexOf('chrome') === -1) return MicSafariGif;
        return MicChromeGif; // Default to Chrome if unknown
    }, []);

    const handleTryAgain = () => {
        window.location.reload();
    };

    const handleClose = () => {
        hidePopup('micPermissionPopup');
    };

    return (
        <div className="mic-permission-popup ct-flex ct-fcol">
            <button type="button" className="close-btn ct-absolute ct-cursor" onClick={handleClose}>
                <CloseIcon />
            </button>

            <div className="mic-permission-header ct-flex ct-fcol ct-wFull">
                <h2 className="mic-permission-title">{t('common.MIC_PERMISSION_TITLE')}</h2>
                <p className="mic-permission-subtitle">{t('common.MIC_PERMISSION_SUBTITLE')}</p>
            </div>

            <div className="mic-permission-media ct-flexCenter ct-wFull">
                <img src={getBrowserGif} alt="Microphone Permission Guide" className="mic-permission-gif" />
            </div>

            <div className="mic-permission-steps ct-flex ct-fcol ct-wFull">
                <ul className="mic-permission-list ct-flex ct-fcol ct-gap30">
                    <li className="mic-permission-item ct-flex ct-aiCenter ct-gap12">
                        <span className="dot"></span>
                        <p>{t('common.MIC_PERMISSION_STEP1')}</p>
                    </li>
                    <li className="mic-permission-item ct-flex ct-aiCenter ct-gap12">
                        <span className="dot"></span>
                        <p>{t('common.MIC_PERMISSION_STEP2')}</p>
                    </li>
                    <li className="mic-permission-item ct-flex ct-aiCenter ct-gap12">
                        <span className="dot"></span>
                        <p>{t('common.MIC_PERMISSION_STEP3')}</p>
                    </li>
                </ul>
            </div>

            <div className="mic-permission-actions ct-flexCenter ct-wFull">
                <button className="mic-try-again-btn ct-flexCenter ct-cursor" onClick={handleTryAgain}>
                    {t('common.TRY_AGAIN')}
                </button>
            </div>
        </div>
    );
};

export default MicrophonePermissionPopup;
